import AmenitiesSection from './AmenitiesSection';

export default AmenitiesSection;
